import { render, staticRenderFns } from "./ListItemBoolean.vue?vue&type=template&id=1629f28f&scoped=true&"
import script from "./ListItemBoolean.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ListItemBoolean.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1629f28f",
  null
  
)

export default component.exports